import api from '.';

// Create a hand-mounted sample in the database
// params: { project_uuid: string, sample_name: string, notes?: string }
export function createHandMountedSample(params) {
  return api.post(params, '/lims/hand_mounted_sample').safeJson();
}
